import { API } from "aws-amplify";
import * as queries from "@/graphql/queries";
import * as mutations from "@/graphql/mutations";
import { findByOwner } from "@/helpers";
export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    comment: (state, rootState) => {
      return (id) => {
        const comment = state.items.filter((comment) => comment.id === id);

        if (!comment) return null;
        return {
          ...comment[0],
          get author() {
            const author = findByOwner(rootState.user.users, comment[0].owner);
            // const author = rootState.user.users[0].id;
            if (!author) {
              return null;
            }
            return author;
          },
        };
      };
    },
    commentsByMaterial: (state) => {
      return (materialId) => {
        const comments = state.items
          .filter((comment) => comment.materialCommentsId === materialId)
          .sort(function (a, b) {
            return a.createdAt > b.createdAt ? 1 : -1;
          });
        if (!comments) return null;
        return comments;
      };
    },
  },
  actions: {
    //使わない
    async getComments({ commit }) {
      const results = await API.graphql({
        query: queries.listComments,
      });

      commit("setComments", results.data.listComments.items);
    },

    async createComment({ dispatch }, { data }) {
      await API.graphql({
        query: mutations.createComment,
        variables: { input: data },
        authMode: "AMAZON_COGNITO_USER_POOLS",
      });
      const message = "コメントが登録されました";
      dispatch("utils/openSnackbar", message, { root: true });
      //STATEの更新
      dispatch("getComments");
    },
    async updateComment({ dispatch }, { id, content }) {
      const data = { id: id, content: content };
      await API.graphql({
        query: mutations.updateComment,
        variables: { input: data },
        authMode: "AMAZON_COGNITO_USER_POOLS",
      });
      const message = "コメントを更新しました";
      dispatch("utils/openSnackbar", message, { root: true });
      //STATEの更新
      dispatch("getComments");
    },
    async deleteComment({ state, dispatch }, { item }) {
      const data = { id: item.id }; // 削除したい材料のIDを入れる
      await API.graphql({
        query: mutations.deleteComment,
        variables: { input: data },
        authMode: "AMAZON_COGNITO_USER_POOLS",
      });
      const i = state.items.indexOf(item);
      if (i > -1) {
        state.items.splice(i, 1);
      }
      const message = "コメントを削除しました";
      dispatch("utils/openSnackbar", message, { root: true });
      //STATEの更新
      dispatch("getComments");
    },
  },
  mutations: {
    setComments(state, comments) {
      state.items = comments;
    },
  },
};
